import { transformAddressToSelectOption } from 'app/utils/helpers/transforms.helper'

export const emptyShippingConfig: ShippingConfigFV = {
  enabled: false,
  method: null,
  carriers: [],
  make_shipping_free: false,
  own_shipping: {
    enabled: false,
    shipping_price: null,
    courier_name: null
  },
  returns: {
    accept_return: false,
    return_days: null,
    return_paid_by: null,
    return_policy_info: null,
    return_address: null
  }
}

export const createEmptyShippingConfigs =
  (): ShippingConfigsForm['shipping_configs'] => ({
    domestic: {
      ...emptyShippingConfig,
      own_shipping: { ...emptyShippingConfig.own_shipping },
      returns: { ...emptyShippingConfig.returns }
    },
    international: {
      ...emptyShippingConfig,
      own_shipping: { ...emptyShippingConfig.own_shipping },
      returns: { ...emptyShippingConfig.returns }
    }
  })

export const getDispatchAddressKey = (
  address?: ShippingConfigsForm['dispatch_address'] | null
) =>
  address?.value?.id ?? address?.value?.full_address ?? address?.label ?? null

export const hasDispatchAddressValue = (
  address?: ShippingConfigsForm['dispatch_address'] | null
) => !!address?.value?.full_country_name

export const isOwnShippingMethod = (
  config?: Pick<ShippingConfigFV, 'method' | 'own_shipping'> | null
) => config?.method === 'own_shipping' || !!config?.own_shipping?.enabled

export const toIntegratedShippingConfig = (
  config: ShippingConfigFV
): ShippingConfigFV => ({
  ...config,
  method: config.enabled ? 'integrated' : null,
  own_shipping: {
    enabled: false,
    shipping_price: null,
    courier_name: null
  }
})

export const mapShippingConfigToFV = (
  config?: ShippingConfig
): ShippingConfigFV => {
  if (!config) return emptyShippingConfig

  const isOwnShipping = !!config.own_shipping?.enabled
  const method: ShippingConfigMethod | null = !config.enabled
    ? null
    : isOwnShipping
    ? 'own_shipping'
    : 'integrated'

  return {
    enabled: !!config.enabled,
    method,
    carriers: config.carriers ?? [],
    make_shipping_free: !!config.make_shipping_free,
    own_shipping: {
      enabled: isOwnShipping,
      shipping_price: config.own_shipping?.shipping_price ?? null,
      courier_name: config.own_shipping?.courier_name ?? null
    },
    returns: {
      accept_return: !!config.returns?.accept_return,
      return_days: config.returns?.return_days ?? null,
      return_paid_by: config.returns?.return_paid_by ?? null,
      return_policy_info: config.returns?.return_policy_info ?? null,
      return_address: transformAddressToSelectOption<Address>(
        config.returns?.return_address as Address
      )
    }
  }
}
